import { render } from "./product-detail.vue?vue&type=template&id=20b7fdb6&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=20b7fdb6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20b7fdb6"

export default script